import { render, staticRenderFns } from "./Especie.vue?vue&type=template&id=07e309a1&scoped=true"
import script from "./Especie.vue?vue&type=script&lang=js"
export * from "./Especie.vue?vue&type=script&lang=js"
import style0 from "../../../../css/crud.css?vue&type=style&index=0&id=07e309a1&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e309a1",
  null
  
)

export default component.exports